import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { UserFormStateService } from '../../module/users/Service/formStateService';

@Component({
  selector: 'formly-field-button',
  template: `
    <div class="flex">
      <p-button [severity]="props['severity']" (click)="onClick($event)"
      [raised]="true" [label]="props.label" >
      </p-button>
    </div>
  `,
  styles: [
    `
   ::ng-deep {
    .p-button {
   background: linear-gradient(135deg, #FFD700, #FFA500);
    border: none;
    color: #0F172A;
    padding: 10px 16px;
    font-size: 14px;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    border-radius: 6px;
    outline-color: transparent;
    height: 44px;
}
// .p-button:not(:disabled):hover {
//     background: #FF8C00;
//     color: #ffffff;
//     border-color: #FF8C00;
// }
}
    `
  ]
})
export class FormlyFieldButton extends FieldType {
  customerId: any = this.formStateService.getUserId();
  constructor(private formStateService: UserFormStateService) {
    super();
  }
  onClick($event: Event) {
    if (this.props['onClick']) {
      this.props['onClick']($event);
    }
  }
}